import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
let header = new HttpHeaders();
header = header.set('Content-Type', 'application/json; charset=utf-8');
@Injectable({
  providedIn: 'root'
})
export class CommonService {

  baseUrl: string = environment.serviceUrl;
  constructor(private httpClient: HttpClient) { }

  sendemail(email: string, emailtype: string): Observable<any> {  
    return this.httpClient.post(this.baseUrl + 'api/SendMailApi/sendemail/' + email + '/' + emailtype, { email }, { headers: header, observe: 'response' });
  }

 
}
